import { Route, Routes, Navigate } from "react-router-dom";
import { useState, useEffect } from "react";
import Login from "./components/Login/Login";
import Signup from "./components/SignUp/SignUp";
import UserDashboard from "./components/UserDashboard/UserDashboard";
import DetailPage from "./components/DetailPage/DetailPage";
import Form from "./components/Form/Form";
import FormTemplatesListPage from "./components/Form/FormTemplatesListPage";
import FormTemplateEditorPage from "./components/Form/FormTemplateEditorPage";
import ChatApp from "./components/ChatApp/ChatApp";
import History from "./components/History/History";
import Lists from "./components/Lists/Lists";
import Calculator from "./components/Calculator/Calculator";
import Tranzyt from "./components/Tranzyt/Tranzyt";
import CalculatorZrealizowanePrzygotowane from "./components/Calculator/CalculatorZrealizowanePrzygotowane";
import Traces from "./components/Traces/Traces";
import AdminPanel from "./components/AdminPanel/AdminPanel";
import { Chart, ArcElement, Tooltip, Legend } from "chart.js";
import RejestrWnioskow from "./components/RejestrWnioskow/RejestrWnioskow";
import NowyWniosek from "./components/RejestrWnioskow/NowyWniosek";
import EditWniosek1 from "./components/RejestrWnioskow/EditWniosek1";
import RejestrLists from "./components/RejestrWnioskow/RejestrLists";
import UniwersalListEksport from "./components/CustomsDeclarationForms/UniwersalListEksport/UniwersalListEksport";
import UniwersalListImport from "./components/CustomsDeclarationForms/UniwersalListImport/UniwersalListImport";
import UniwersalListTranzyt from "./components/CustomsDeclarationForms/UniwersalListTranzyt/UniwersalListTranzyt";
import Archive from "./components/ArchivePanel/Archive";
import ArchiveTranzyt from "./components/Tranzyt/TranzytArchive";
import Dashboard from "./components/MagazynWarszawa/Dashboard";
import ZwrotyIBledy from "./components/MagazynWarszawa/ZwrotyIBledy";
import Handling from "./components/MagazynWarszawa/Handling";
import NowyHandling from "./components/MagazynWarszawa/NowyHandling";
import DopiszDane from "./components/MagazynWarszawa/DopiszDane";
import MagazynWarszawaLists from "./components/MagazynWarszawa/MagazynWarszawaLists";
import KontrolaWewnetrzna from "./components/KontrolaWewnetrzna/KontrolaWewnetrzna";
import DodajDoKW from "./components/KontrolaWewnetrzna/DodajDoKW";
import KWDetail from "./components/KontrolaWewnetrzna/KWDetail";
import KWLists from "./components/KontrolaWewnetrzna/KWLists";
import ShellLayout from "./components/common/ShellLayout";
import RaportCzasow from "./components/RaportCzasow/RaportCzasow";
import RaportMagazynWarszawa from "./components/RaportMagazynWarszawa/RaportMagazynWarszawa";
Chart.register(ArcElement, Tooltip, Legend);

function App() {
  const [authenticated, setAuthenticated] = useState(
    localStorage.getItem("token") !== null,
  );

  const handleLogout = () => {
    localStorage.clear();
    setAuthenticated(false);
  };

  useEffect(() => {
    setAuthenticated(localStorage.getItem("token") !== null);
  }, []);

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route
        path="/login"
        element={<Login setAuthenticated={setAuthenticated} />}
      />
      <Route path="/signup" element={<Signup />} />
      <Route
        element={
          authenticated ? <ShellLayout /> : <Navigate to="/login" replace />
        }
      >
        <Route path="/user" element={<UserDashboard handleLogout={handleLogout} />} />
        <Route path="/form" element={<Form />} />
        <Route path="/tranzyt" element={<Tranzyt />} />
        <Route path="/archive" element={<Archive />} />
        <Route path="/archiveTranzyt" element={<ArchiveTranzyt />} />
        <Route path="/detail/:nrRef/:id" element={<DetailPage />} />
        <Route path="/magazynWarszawa" element={<Dashboard />} />
        <Route path="/magazynWarszawaZwrotyIBledy" element={<ZwrotyIBledy />} />
        <Route path="/magazynWarszawaHandling" element={<Handling />} />
        <Route path="/magazynWarszawaNowyHandling" element={<NowyHandling />} />
        <Route path="/magazynWarszawaNowyHandling/dopisz-dane" element={<DopiszDane />} />
        <Route path="/magazynWarszawaLists" element={<MagazynWarszawaLists />} />
        <Route path="/rejestrWnioskow" element={<RejestrWnioskow />} />
        <Route path="/rejestrWnioskow/:id" element={<EditWniosek1 />} />
        <Route path="/kontrolaWewnetrzna" element={<KontrolaWewnetrzna />} />
        <Route path="/traces" element={<Traces />} />
        <Route path="/history" element={<History />} />
        <Route path="/list" element={<Lists />} />
        <Route path="/adminPanel" element={<AdminPanel />} />
        <Route path="/raportMagazynWarszawa" element={<RaportMagazynWarszawa />} />
        <Route path="/raportCzasowOdpraw" element={<RaportCzasow />} />
        <Route path="/calculator" element={<Calculator />} />
        <Route path="/calculatorZrealizowan&Przygotowane" element={<CalculatorZrealizowanePrzygotowane />} />
        <Route path="/kontrolaWewnetrzna/szczegoly/:id" element={<KWDetail />} />
      </Route>
      <Route
        path="/form/templates"
        element={
          authenticated ? (
            <FormTemplatesListPage />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/form/templates/new"
        element={
          authenticated ? (
            <FormTemplateEditorPage />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/form/templates/:id/edit"
        element={
          authenticated ? (
            <FormTemplateEditorPage />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/chat"
        element={authenticated ? <ChatApp /> : <Navigate to="/login" replace />}
      />
      <Route
        path="/dodajDoKW"
        element={
          authenticated ? <DodajDoKW /> : <Navigate to="/login" replace />
        }
      />
      <Route
        path="/kontrolaWewnetrzna/listy"
        element={authenticated ? <KWLists /> : <Navigate to="/login" replace />}
      />
      <Route
        path="/nowyWniosek"
        element={
          authenticated ? <NowyWniosek /> : <Navigate to="/login" replace />
        }
      />
      <Route
        path="/rejestrLists"
        element={
          authenticated ? <RejestrLists /> : <Navigate to="/login" replace />
        }
      />
      <Route
        path="/UniwersalListEksport/:nrRef/:id"
        element={
          authenticated ? (
            <UniwersalListEksport />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/UniwersalListImport/:nrRef/:id"
        element={
          authenticated ? (
            <UniwersalListImport />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/UniwersalListTranzyt/:nrRef/:id"
        element={
          authenticated ? (
            <UniwersalListTranzyt />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
    </Routes>
  );
}

export default App;
